//对于axios进行二次封装
import axios from "axios";
//引入进度条
import nprogress from 'nprogress'

//引入进度条样式
import NProgress from 'nprogress'
import "nprogress/nprogress.css";
//start:进度条开始done：进度条结束
//加解密接口数据
import { encryptData, decryptData } from '@/utils/crypto';
//1.利用axios对象的方法create，去创建一个axios实例
//2.request就是axios.只不过稍微配置一下
const requests = axios.create({
	//配置对象
	//基础路径，发请求的时候，路径当中会出现api
	//开发环境
//baseURL:"http://127.0.0.1:3007",
	//发布环境
//baseURL:"http://1.15.68.46:9001",

baseURL:"https://merinofans.com:9001",
//baseURL:"https://1.15.68.46:9001",
	//代表请求超时的时间5s
	timeout:5000,
	//全局请求头

	//multipart/form-data,application/x-www-form-urlencoded，'Content-Type':'image/jpeg',application/javascript
	headers:{
		'Content-Type':'application/x-www-form-urlencoded;charset=utf-8',
     'X-Custom-Secret':'your-super-secret-key-plus'//自定义请求头
	},
   // onUploadProgress: function (progressEvent) {
   //    console.log(progressEvent)
   //  },
   // onUploadProgress: progressEvent => {
   //   if (progressEvent.lengthComputable) {
   //     let aaa = (progressEvent.loaded / progressEvent.total).toFixed(2) * 100  // 进度条百分比
   //     console.log(aaa)
   //   }
   // },
})
requests.interceptors.request.use(config =>{
	//console.log(config)
  if (config.data && !config.data.encrypted) {
             config.data = {
                 encrypted: true,
                 data: encryptData(config.data),
             };
         }
	NProgress.start()
	config.headers.Authorization = window.sessionStorage.getItem('token')
	return config
})
//在request 拦截器中，隐藏进度条NProgress.done();
requests.interceptors.response.use(config => {
  if (config.data && config.data.encrypted) {
     config.data = decryptData(config.data.data);
  }
	NProgress.done()
	return config
})

//对外暴露
export default requests;
